/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AcceptRecomendedItemsCommandResult } from '../models/accept-recomended-items-command-result';
import { apiNurseryManagerOrderDetailsAcceptRecommendedItemPatch } from '../fn/order-details/api-nursery-manager-order-details-accept-recommended-item-patch';
import { ApiNurseryManagerOrderDetailsAcceptRecommendedItemPatch$Params } from '../fn/order-details/api-nursery-manager-order-details-accept-recommended-item-patch';
import { apiNurseryManagerOrderDetailsAcceptRecommendedItemPatch$Plain } from '../fn/order-details/api-nursery-manager-order-details-accept-recommended-item-patch-plain';
import { ApiNurseryManagerOrderDetailsAcceptRecommendedItemPatch$Plain$Params } from '../fn/order-details/api-nursery-manager-order-details-accept-recommended-item-patch-plain';
import { apiNurseryManagerOrderDetailsAddRecommendedItemPost } from '../fn/order-details/api-nursery-manager-order-details-add-recommended-item-post';
import { ApiNurseryManagerOrderDetailsAddRecommendedItemPost$Params } from '../fn/order-details/api-nursery-manager-order-details-add-recommended-item-post';
import { apiNurseryManagerOrderDetailsAddRecommendedItemPost$Plain } from '../fn/order-details/api-nursery-manager-order-details-add-recommended-item-post-plain';
import { ApiNurseryManagerOrderDetailsAddRecommendedItemPost$Plain$Params } from '../fn/order-details/api-nursery-manager-order-details-add-recommended-item-post-plain';
import { apiNurseryManagerOrderDetailsDeleteOrderDetailsDelete } from '../fn/order-details/api-nursery-manager-order-details-delete-order-details-delete';
import { ApiNurseryManagerOrderDetailsDeleteOrderDetailsDelete$Params } from '../fn/order-details/api-nursery-manager-order-details-delete-order-details-delete';
import { apiNurseryManagerOrderDetailsDeleteOrderDetailsDelete$Plain } from '../fn/order-details/api-nursery-manager-order-details-delete-order-details-delete-plain';
import { ApiNurseryManagerOrderDetailsDeleteOrderDetailsDelete$Plain$Params } from '../fn/order-details/api-nursery-manager-order-details-delete-order-details-delete-plain';
import { apiNurseryManagerOrderDetailsGetOrderDetailsPost } from '../fn/order-details/api-nursery-manager-order-details-get-order-details-post';
import { ApiNurseryManagerOrderDetailsGetOrderDetailsPost$Params } from '../fn/order-details/api-nursery-manager-order-details-get-order-details-post';
import { apiNurseryManagerOrderDetailsGetOrderDetailsPost$Plain } from '../fn/order-details/api-nursery-manager-order-details-get-order-details-post-plain';
import { ApiNurseryManagerOrderDetailsGetOrderDetailsPost$Plain$Params } from '../fn/order-details/api-nursery-manager-order-details-get-order-details-post-plain';
import { apiNurseryManagerOrderDetailsGetOrdersDetailsPost } from '../fn/order-details/api-nursery-manager-order-details-get-orders-details-post';
import { ApiNurseryManagerOrderDetailsGetOrdersDetailsPost$Params } from '../fn/order-details/api-nursery-manager-order-details-get-orders-details-post';
import { apiNurseryManagerOrderDetailsGetOrdersDetailsPost$Plain } from '../fn/order-details/api-nursery-manager-order-details-get-orders-details-post-plain';
import { ApiNurseryManagerOrderDetailsGetOrdersDetailsPost$Plain$Params } from '../fn/order-details/api-nursery-manager-order-details-get-orders-details-post-plain';
import { apiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost } from '../fn/order-details/api-nursery-manager-order-details-get-recomended-orders-details-post';
import { ApiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost$Params } from '../fn/order-details/api-nursery-manager-order-details-get-recomended-orders-details-post';
import { apiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost$Plain } from '../fn/order-details/api-nursery-manager-order-details-get-recomended-orders-details-post-plain';
import { ApiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost$Plain$Params } from '../fn/order-details/api-nursery-manager-order-details-get-recomended-orders-details-post-plain';
import { apiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost } from '../fn/order-details/api-nursery-manager-order-details-set-order-details-approve-qty-post';
import { ApiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost$Params } from '../fn/order-details/api-nursery-manager-order-details-set-order-details-approve-qty-post';
import { apiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost$Plain } from '../fn/order-details/api-nursery-manager-order-details-set-order-details-approve-qty-post-plain';
import { ApiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost$Plain$Params } from '../fn/order-details/api-nursery-manager-order-details-set-order-details-approve-qty-post-plain';
import { apiNurseryManagerOrderDetailsUpdateOrderDetailsPatch } from '../fn/order-details/api-nursery-manager-order-details-update-order-details-patch';
import { ApiNurseryManagerOrderDetailsUpdateOrderDetailsPatch$Params } from '../fn/order-details/api-nursery-manager-order-details-update-order-details-patch';
import { apiNurseryManagerOrderDetailsUpdateOrderDetailsPatch$Plain } from '../fn/order-details/api-nursery-manager-order-details-update-order-details-patch-plain';
import { ApiNurseryManagerOrderDetailsUpdateOrderDetailsPatch$Plain$Params } from '../fn/order-details/api-nursery-manager-order-details-update-order-details-patch-plain';
import { CreateOrderDetailsCommandResult } from '../models/create-order-details-command-result';
import { DeleteOrderDetailsCommandResult } from '../models/delete-order-details-command-result';
import { GetOrderDetailsQueryResult } from '../models/get-order-details-query-result';
import { GetOrdersDetailsQueryResult } from '../models/get-orders-details-query-result';
import { GetRecomendedOrdersDetailsQueryResult } from '../models/get-recomended-orders-details-query-result';
import { SetOrderFinalQtyCommandResult } from '../models/set-order-final-qty-command-result';
import { UpdateOrderDetailsCommandResult } from '../models/update-order-details-command-result';

@Injectable({ providedIn: 'root' })
export class OrderDetailsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiNurseryManagerOrderDetailsGetOrderDetailsPost()` */
  static readonly ApiNurseryManagerOrderDetailsGetOrderDetailsPostPath = '/api/NurseryManager/OrderDetails/GetOrderDetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderDetailsGetOrderDetailsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsGetOrderDetailsPost$Plain$Response(params?: ApiNurseryManagerOrderDetailsGetOrderDetailsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrderDetailsQueryResult>> {
    return apiNurseryManagerOrderDetailsGetOrderDetailsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderDetailsGetOrderDetailsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsGetOrderDetailsPost$Plain(params?: ApiNurseryManagerOrderDetailsGetOrderDetailsPost$Plain$Params, context?: HttpContext): Observable<GetOrderDetailsQueryResult> {
    return this.apiNurseryManagerOrderDetailsGetOrderDetailsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetOrderDetailsQueryResult>): GetOrderDetailsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderDetailsGetOrderDetailsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsGetOrderDetailsPost$Response(params?: ApiNurseryManagerOrderDetailsGetOrderDetailsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrderDetailsQueryResult>> {
    return apiNurseryManagerOrderDetailsGetOrderDetailsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderDetailsGetOrderDetailsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsGetOrderDetailsPost(params?: ApiNurseryManagerOrderDetailsGetOrderDetailsPost$Params, context?: HttpContext): Observable<GetOrderDetailsQueryResult> {
    return this.apiNurseryManagerOrderDetailsGetOrderDetailsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetOrderDetailsQueryResult>): GetOrderDetailsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerOrderDetailsGetOrdersDetailsPost()` */
  static readonly ApiNurseryManagerOrderDetailsGetOrdersDetailsPostPath = '/api/NurseryManager/OrderDetails/GetOrdersDetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderDetailsGetOrdersDetailsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsGetOrdersDetailsPost$Plain$Response(params?: ApiNurseryManagerOrderDetailsGetOrdersDetailsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrdersDetailsQueryResult>> {
    return apiNurseryManagerOrderDetailsGetOrdersDetailsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderDetailsGetOrdersDetailsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsGetOrdersDetailsPost$Plain(params?: ApiNurseryManagerOrderDetailsGetOrdersDetailsPost$Plain$Params, context?: HttpContext): Observable<GetOrdersDetailsQueryResult> {
    return this.apiNurseryManagerOrderDetailsGetOrdersDetailsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetOrdersDetailsQueryResult>): GetOrdersDetailsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderDetailsGetOrdersDetailsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsGetOrdersDetailsPost$Response(params?: ApiNurseryManagerOrderDetailsGetOrdersDetailsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrdersDetailsQueryResult>> {
    return apiNurseryManagerOrderDetailsGetOrdersDetailsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderDetailsGetOrdersDetailsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsGetOrdersDetailsPost(params?: ApiNurseryManagerOrderDetailsGetOrdersDetailsPost$Params, context?: HttpContext): Observable<GetOrdersDetailsQueryResult> {
    return this.apiNurseryManagerOrderDetailsGetOrdersDetailsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetOrdersDetailsQueryResult>): GetOrdersDetailsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost()` */
  static readonly ApiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPostPath = '/api/NurseryManager/OrderDetails/GetRecomendedOrdersDetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost$Plain$Response(params?: ApiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetRecomendedOrdersDetailsQueryResult>> {
    return apiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost$Plain(params?: ApiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost$Plain$Params, context?: HttpContext): Observable<GetRecomendedOrdersDetailsQueryResult> {
    return this.apiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetRecomendedOrdersDetailsQueryResult>): GetRecomendedOrdersDetailsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost$Response(params?: ApiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetRecomendedOrdersDetailsQueryResult>> {
    return apiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost(params?: ApiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost$Params, context?: HttpContext): Observable<GetRecomendedOrdersDetailsQueryResult> {
    return this.apiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetRecomendedOrdersDetailsQueryResult>): GetRecomendedOrdersDetailsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerOrderDetailsAddRecommendedItemPost()` */
  static readonly ApiNurseryManagerOrderDetailsAddRecommendedItemPostPath = '/api/NurseryManager/OrderDetails/AddRecommendedItem';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderDetailsAddRecommendedItemPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsAddRecommendedItemPost$Plain$Response(params?: ApiNurseryManagerOrderDetailsAddRecommendedItemPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateOrderDetailsCommandResult>> {
    return apiNurseryManagerOrderDetailsAddRecommendedItemPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderDetailsAddRecommendedItemPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsAddRecommendedItemPost$Plain(params?: ApiNurseryManagerOrderDetailsAddRecommendedItemPost$Plain$Params, context?: HttpContext): Observable<CreateOrderDetailsCommandResult> {
    return this.apiNurseryManagerOrderDetailsAddRecommendedItemPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateOrderDetailsCommandResult>): CreateOrderDetailsCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderDetailsAddRecommendedItemPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsAddRecommendedItemPost$Response(params?: ApiNurseryManagerOrderDetailsAddRecommendedItemPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateOrderDetailsCommandResult>> {
    return apiNurseryManagerOrderDetailsAddRecommendedItemPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderDetailsAddRecommendedItemPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsAddRecommendedItemPost(params?: ApiNurseryManagerOrderDetailsAddRecommendedItemPost$Params, context?: HttpContext): Observable<CreateOrderDetailsCommandResult> {
    return this.apiNurseryManagerOrderDetailsAddRecommendedItemPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateOrderDetailsCommandResult>): CreateOrderDetailsCommandResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost()` */
  static readonly ApiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPostPath = '/api/NurseryManager/OrderDetails/SetOrderDetailsApproveQty';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost$Plain$Response(params?: ApiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SetOrderFinalQtyCommandResult>> {
    return apiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost$Plain(params?: ApiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost$Plain$Params, context?: HttpContext): Observable<SetOrderFinalQtyCommandResult> {
    return this.apiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<SetOrderFinalQtyCommandResult>): SetOrderFinalQtyCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost$Response(params?: ApiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SetOrderFinalQtyCommandResult>> {
    return apiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost(params?: ApiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost$Params, context?: HttpContext): Observable<SetOrderFinalQtyCommandResult> {
    return this.apiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<SetOrderFinalQtyCommandResult>): SetOrderFinalQtyCommandResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerOrderDetailsUpdateOrderDetailsPatch()` */
  static readonly ApiNurseryManagerOrderDetailsUpdateOrderDetailsPatchPath = '/api/NurseryManager/OrderDetails/UpdateOrderDetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderDetailsUpdateOrderDetailsPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsUpdateOrderDetailsPatch$Plain$Response(params?: ApiNurseryManagerOrderDetailsUpdateOrderDetailsPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateOrderDetailsCommandResult>> {
    return apiNurseryManagerOrderDetailsUpdateOrderDetailsPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderDetailsUpdateOrderDetailsPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsUpdateOrderDetailsPatch$Plain(params?: ApiNurseryManagerOrderDetailsUpdateOrderDetailsPatch$Plain$Params, context?: HttpContext): Observable<UpdateOrderDetailsCommandResult> {
    return this.apiNurseryManagerOrderDetailsUpdateOrderDetailsPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateOrderDetailsCommandResult>): UpdateOrderDetailsCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderDetailsUpdateOrderDetailsPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsUpdateOrderDetailsPatch$Response(params?: ApiNurseryManagerOrderDetailsUpdateOrderDetailsPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateOrderDetailsCommandResult>> {
    return apiNurseryManagerOrderDetailsUpdateOrderDetailsPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderDetailsUpdateOrderDetailsPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsUpdateOrderDetailsPatch(params?: ApiNurseryManagerOrderDetailsUpdateOrderDetailsPatch$Params, context?: HttpContext): Observable<UpdateOrderDetailsCommandResult> {
    return this.apiNurseryManagerOrderDetailsUpdateOrderDetailsPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateOrderDetailsCommandResult>): UpdateOrderDetailsCommandResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerOrderDetailsAcceptRecommendedItemPatch()` */
  static readonly ApiNurseryManagerOrderDetailsAcceptRecommendedItemPatchPath = '/api/NurseryManager/OrderDetails/AcceptRecommendedItem';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderDetailsAcceptRecommendedItemPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsAcceptRecommendedItemPatch$Plain$Response(params?: ApiNurseryManagerOrderDetailsAcceptRecommendedItemPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AcceptRecomendedItemsCommandResult>> {
    return apiNurseryManagerOrderDetailsAcceptRecommendedItemPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderDetailsAcceptRecommendedItemPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsAcceptRecommendedItemPatch$Plain(params?: ApiNurseryManagerOrderDetailsAcceptRecommendedItemPatch$Plain$Params, context?: HttpContext): Observable<AcceptRecomendedItemsCommandResult> {
    return this.apiNurseryManagerOrderDetailsAcceptRecommendedItemPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AcceptRecomendedItemsCommandResult>): AcceptRecomendedItemsCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderDetailsAcceptRecommendedItemPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsAcceptRecommendedItemPatch$Response(params?: ApiNurseryManagerOrderDetailsAcceptRecommendedItemPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<AcceptRecomendedItemsCommandResult>> {
    return apiNurseryManagerOrderDetailsAcceptRecommendedItemPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderDetailsAcceptRecommendedItemPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsAcceptRecommendedItemPatch(params?: ApiNurseryManagerOrderDetailsAcceptRecommendedItemPatch$Params, context?: HttpContext): Observable<AcceptRecomendedItemsCommandResult> {
    return this.apiNurseryManagerOrderDetailsAcceptRecommendedItemPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<AcceptRecomendedItemsCommandResult>): AcceptRecomendedItemsCommandResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerOrderDetailsDeleteOrderDetailsDelete()` */
  static readonly ApiNurseryManagerOrderDetailsDeleteOrderDetailsDeletePath = '/api/NurseryManager/OrderDetails/DeleteOrderDetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderDetailsDeleteOrderDetailsDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsDeleteOrderDetailsDelete$Plain$Response(params?: ApiNurseryManagerOrderDetailsDeleteOrderDetailsDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteOrderDetailsCommandResult>> {
    return apiNurseryManagerOrderDetailsDeleteOrderDetailsDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderDetailsDeleteOrderDetailsDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsDeleteOrderDetailsDelete$Plain(params?: ApiNurseryManagerOrderDetailsDeleteOrderDetailsDelete$Plain$Params, context?: HttpContext): Observable<DeleteOrderDetailsCommandResult> {
    return this.apiNurseryManagerOrderDetailsDeleteOrderDetailsDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteOrderDetailsCommandResult>): DeleteOrderDetailsCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderDetailsDeleteOrderDetailsDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsDeleteOrderDetailsDelete$Response(params?: ApiNurseryManagerOrderDetailsDeleteOrderDetailsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteOrderDetailsCommandResult>> {
    return apiNurseryManagerOrderDetailsDeleteOrderDetailsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderDetailsDeleteOrderDetailsDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderDetailsDeleteOrderDetailsDelete(params?: ApiNurseryManagerOrderDetailsDeleteOrderDetailsDelete$Params, context?: HttpContext): Observable<DeleteOrderDetailsCommandResult> {
    return this.apiNurseryManagerOrderDetailsDeleteOrderDetailsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteOrderDetailsCommandResult>): DeleteOrderDetailsCommandResult => r.body)
    );
  }

}
